import {
  Box,
  Button,
  Container,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  Grid,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { DateRangePicker } from "react-date-range";
import { defaultStaticRanges, createStaticRanges } from "react-date-range";
import {
  addDays,
  eachDayOfInterval,
  addMonths,
  startOfMonth,
  endOfMonth,
  subMonths,
} from "date-fns";
import { CalendarMonth } from "@mui/icons-material";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css";
import CampaignIcon from "@mui/icons-material/Campaign";
import RechartsLineChart from "./Charts/RechartsLineChart";
import { useDispatch, useSelector } from "react-redux";
import {
  getCampaignTableDetails,
  getCampGraphResult,
  getFilterDataCampaign,
  getNetworkTableDetails,
} from "../../../redux/features/clicksSlice";
import Datatable from "../../commonLayout/Datatable";
import indianNumberFormatter from "../../../utils/indianNumberFormatter";
import StateCard from "./Charts/stateCard/StateCard";
import {
  calanderDateConverter,
  dateConverter,
} from "../../../utils/customDateFunction";
import { Helmet } from "react-helmet";
import indianNumberFormatterWithDecimal from "../../../utils/indianNumberFormatterWithDecimal";

function FIlterChart() {
  const totalClicks = "Clicks";
  const totalConversion = "Conversion";
  const totalPending = "Pending";
  const totalApproved = "Approved";
  const totalCancelled = "Cancelled";
  const totalCancelledConversion = "Cancelled Conversion";
  const totalApprovedConversion = "Approved Conversion";

  const dispatch = useDispatch();
  const {
    campGraphResult,
    networkFilterData,
    campFilterData,
    loginIdFilterData,
    campTableData,
    networkTableData,
    // total_camp_count,
    // total_network_count,
  } = useSelector((state) => state.clicks);
  const [dateRanges, setDateRanges] = useState([
    {
      startDate: addDays(new Date(), -14),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  // const [paginationModel, setPaginationModel] = React.useState({
  //   pageSize: 5,
  //   page: 0,
  // });

  // const [paginationModelNetwork, setPaginationModelNetwork] = React.useState({
  //   pageSize: 5,
  //   page: 0,
  // });
  const [campaign, setCampaign] = useState("");
  const [partner, setPartner] = useState("");
  const [login_id, setLogin_id] = useState("");
  const [toggleCalender, setToggleCalender] = useState(false);
  // const [network_pages, setNetwork_pages] = useState(1);
  // const [camp_pages, setCamp_pages] = useState(1);
  const [campaignSearchTerm, setCampainSearchTerm] = useState("");
  const [networkSearchTerm, setNetworkSearchTerm] = useState("");

  // let type = "date_wise";
  // if (type == "camp_wise") {
  //   columns = [
  // { field: 'id', headerName: 'ID', width: 70 },

  const campTableDataFilteredRows = campaignSearchTerm
    ? campTableData.filter((row) =>
        row.campaign.toLowerCase().includes(campaignSearchTerm.toLowerCase()),
      )
    : campTableData;
  const networkTableDataFilteredRows = networkSearchTerm
    ? networkTableData.filter((row) =>
        row.network.toLowerCase().includes(networkSearchTerm.toLowerCase()),
      )
    : networkTableData;

  const lastTwoMonthsRange = {
    label: "Last 2 Months",
    range: () => ({
      startDate: startOfMonth(subMonths(new Date(), 2)), // Start of 2 months ago
      endDate: endOfMonth(subMonths(new Date(), 1)), // End of last month
    }),
  };

  const customStaticRanges = createStaticRanges([
    ...defaultStaticRanges,
    lastTwoMonthsRange,
  ]);

  const columns = React.useMemo(
    () => [
      {
        field: "campaign",
        headerClassName: "mainColor",
        headerName: "Campaign",
        // width: 130,
        flex: 1,
      },
      {
        field: "total_clicks",
        headerClassName: "mainColor",
        type: "number",
        valueGetter: (value) => {
          if (!value) {
            return value;
          }
          return Number(value.value);
        },
        renderCell: (params) => indianNumberFormatter(params.value),

        headerName: totalClicks,
        flex: 1,
        // width: 150,
      },
      {
        field: "total_conversions",
        headerClassName: "mainColor",
        type: "number",
        valueGetter: (value) => {
          if (!value) {
            return value;
          }
          return Number(value.value);
        },
        renderCell: (params) => indianNumberFormatter(params.value),
        headerName: totalConversion,
        flex: 1,
        // width: 180,
      },
      {
        headerName: totalPending,
        headerClassName: "mainColor",
        type: "number",
        valueGetter: (value) => {
          if (!value) {
            return value;
          }
          return Number(value.value);
        },
        renderCell: (params) => indianNumberFormatterWithDecimal(params.value),
        field: "total_pending",
        flex: 1,
        // width: 150,
      },
      {
        headerName: totalApproved,
        headerClassName: "mainColor ",
        type: "number",
        valueGetter: (value) => {
          if (!value) {
            return value;
          }
          return Number(value.value);
        },
        renderCell: (params) => indianNumberFormatter(params.value),
        field: "total_approved",
        flex: 1,
        // width: 150,
      },
      {
        headerName: totalCancelled,
        headerClassName: "mainColor ",
        type: "number",
        valueGetter: (value) => {
          if (!value) {
            return value;
          }
          return Number(value.value);
        },
        renderCell: (params) => indianNumberFormatter(params.value),
        field: "total_cancelled",
        flex: 1,
        // width: 150,
      },
      {
        headerName: totalCancelledConversion,
        headerClassName: "mainColor ",
        type: "number",
        valueGetter: (value) => {
          if (!value) {
            return value;
          }
          return Number(value.value);
        },
        renderCell: (params) => indianNumberFormatter(params.value),
        field: "total_cancelled_conversion",
        flex: 1,
        // width: 150,
      },
      {
        headerName: totalApprovedConversion,
        headerClassName: "mainColor ",
        type: "number",
        valueGetter: (value) => {
          if (!value) {
            return value;
          }
          return Number(value.value);
        },
        renderCell: (params) => indianNumberFormatter(params.value),
        field: "total_approved_conversion",
        flex: 1,
        // width: 150,
      },
    ],
    [],
  );

  const networkColumns = React.useMemo(
    () => [
      {
        field: "network",
        headerClassName: "mainColor",
        headerName: "Network",
        flex: 1,

        // width: 130,
      },
      {
        field: "total_clicks",
        headerClassName: "mainColor",
        type: "number",
        valueGetter: (value) => {
          if (!value) {
            return value;
          }
          return Number(value.value);
        },
        renderCell: (params) => indianNumberFormatter(params.value),
        headerName: totalClicks,
        // width: 130,
        flex: 1,
      },
      {
        field: "total_conversions",
        headerClassName: "mainColor",
        type: "number",
        valueGetter: (value) => {
          if (!value) {
            return value;
          }
          return Number(value.value);
        },
        renderCell: (params) => indianNumberFormatter(params.value),
        headerName: totalConversion,
        // width: 180,
        flex: 1,
      },
      {
        headerName: totalPending,
        headerClassName: "mainColor",
        field: "total_pending",
        type: "number",
        valueGetter: (value) => {
          if (!value) {
            return value;
          }
          return Number(value.value);
        },
        renderCell: (params) => indianNumberFormatterWithDecimal(params.value),
        // width: 150,
        flex: 1,
      },
      {
        headerName: totalApproved,
        headerClassName: "mainColor",
        field: "total_approved",
        type: "number",
        valueGetter: (value) => {
          if (!value) {
            return value;
          }
          return Number(value.value);
        },
        renderCell: (params) => indianNumberFormatter(params.value),
        // width: 150,
        flex: 1,
      },
      {
        headerName: totalCancelled,
        headerClassName: "mainColor",
        field: "total_cancelled",
        type: "number",
        valueGetter: (value) => {
          if (!value) {
            return value;
          }
          return Number(value.value);
        },
        renderCell: (params) => indianNumberFormatter(params.value),
        // width: 150,
        flex: 1,
      },
      {
        headerName: totalCancelledConversion,
        headerClassName: "mainColor",
        field: "total_cancelled_conversion",
        type: "number",
        valueGetter: (value) => {
          if (!value) {
            return value;
          }
          return Number(value.value);
        },
        renderCell: (params) => indianNumberFormatter(params.value),
        // width: 150,
        flex: 1,
      },
      {
        headerName: totalApprovedConversion,
        headerClassName: "mainColor",
        field: "total_approved_conversion",
        type: "number",
        valueGetter: (value) => {
          if (!value) {
            return value;
          }
          return Number(value.value);
        },
        renderCell: (params) => indianNumberFormatter(params.value),
        // width: 150,
        flex: 1,
      },
    ],
    [],
  );

  useEffect(() => {
    dispatch(
      getCampGraphResult({
        start_date: dateConverter(dateRanges[0].startDate),
        end_date: dateConverter(dateRanges[0].endDate),
        network: partner,
        campaign,
        login_id,
      }),
    );
    dispatch(
      getCampaignTableDetails({
        start_date: dateConverter(dateRanges[0].startDate),
        end_date: dateConverter(dateRanges[0].endDate),
        network: partner,
        campaign: campaign,
        login_id: login_id,
        // camp_pages,
      }),
    );

    dispatch(
      getNetworkTableDetails({
        start_date: dateConverter(dateRanges[0].startDate),
        end_date: dateConverter(dateRanges[0].endDate),
        network: partner,
        campaign,
        login_id,
        // network_pages,
      }),
    );
    dispatch(
      getFilterDataCampaign({
        start_date: dateRanges[0].startDate,
        end_date: dateRanges[0].endDate,
        // network,
        // campaign,
        // login_id,
      }),
    );
  }, [campaign, dateRanges, partner, login_id]);

  // useEffect(() => {
  //   dispatch(
  //     getFilterDataCampaign({
  //       start_date: dateRanges[0].startDate,
  //       end_date: dateRanges[0].endDate,
  //       // network,
  //       // campaign,
  //       // login_id,
  //     })
  //   );
  // }, []);

  const [categories, setCategories] = useState(
    eachDayOfInterval({
      start: dateRanges[0].startDate,
      end: dateRanges[0].endDate,
    }).map((d) => dateConverter(d)),
  );

  const handleDateChange = (item) => {
    // console.log(item, "item date");
    setDateRanges([
      {
        startDate: item.selection.startDate,
        endDate: item.selection.endDate,
        key: "selection",
      },
    ]);

    const dates = eachDayOfInterval({
      start: item.selection.startDate,
      end: item.selection.endDate,
    }).map((d) => dateConverter(d));
    setCategories(dates);

    setToggleCalender(item.selection.startDate === item.selection.endDate);
  };

  // console.log(campGraphResult, "campGraphResult in render");
  // const handleNetworkPagination = (model) => {
  //   setPaginationModelNetwork(model);
  //   dispatch(
  //     getNetworkTableDetails({
  //       start_date: dateConverter(dateRanges[0].startDate),
  //       end_date: dateConverter(dateRanges[0].endDate),
  //       network: partner,
  //       campaign,
  //       login_id,
  //       network_pages: model.page + 1,
  //       searchTerm: networkSearchTerm,
  //     })
  //   );
  // };

  // const handleCampaignPagination = (model) => {
  //   // console.log(model, "model");
  //   setPaginationModel(model);
  //   dispatch(
  //     getCampaignTableDetails({
  //       start_date: dateConverter(dateRanges[0].startDate),
  //       end_date: dateConverter(dateRanges[0].endDate),
  //       network: partner,
  //       campaign,
  //       login_id,
  //       camp_pages: model.page + 1,
  //       searchTerm: campaignSearchTerm,
  //     })
  //   );
  // };
  // console.log(campTableData,"campTableData");
  // console.log(campGraphResult, "campGraphResult");
  // Transform parallel arrays from Redux into Recharts-compatible data
  const chartData = React.useMemo(() => {
    const dates = campGraphResult?.date || [];
    return dates.map((d, i) => ({
      date: d,
      clicks: campGraphResult?.total_clicks?.[i] ?? 0,
      conversion: campGraphResult?.total_conversion?.[i] ?? 0,
      pending: campGraphResult?.total_pending?.[i] ?? 0,
      approved: campGraphResult?.total_approved?.[i] ?? 0,
      cancelled: campGraphResult?.total_cancelled?.[i] ?? 0,
      cancelledConversion:
        campGraphResult?.total_cancelled_conversion?.[i] ?? 0,
      approvedConversion: campGraphResult?.total_approved_conversion?.[i] ?? 0,
    }));
  }, [campGraphResult]);

  const chartProps = React.useMemo(
    () => ({
      hiddenSeries: [totalCancelledConversion, totalApprovedConversion],
      yAxisLeft: { title: "Clicks", color: "#3b82f6" },
      yAxisRight: { title: "Conversions", color: "#22c55e" },
      yAxisRight2: { title: "Revenue", color: "#22c55e" },
      lines: [
        {
          dataKey: "clicks",
          name: totalClicks,
          color: "#3b82f6",
          yAxisId: "left",
        },
        {
          dataKey: "approved",
          name: totalApproved,
          color: "#22c55e",
          yAxisId: "right2",
        },
        {
          dataKey: "pending",
          name: totalPending,
          color: "#f59e0b",
          yAxisId: "right2",
        },
        {
          dataKey: "cancelled",
          name: totalCancelled,
          color: "#ef4444",
          yAxisId: "right2",
        },
        {
          dataKey: "conversion",
          name: totalConversion,
          color: "#22c55e",
          yAxisId: "right",
          dashed: true,
        },
        {
          dataKey: "approvedConversion",
          name: totalApprovedConversion,
          color: "#f59e0b",
          yAxisId: "right",
          dashed: true,
        },
        {
          dataKey: "cancelledConversion",
          name: totalCancelledConversion,
          color: "#ef4444",
          yAxisId: "right",
          dashed: true,
        },
      ],
    }),
    [],
  );

  return (
    <>
      <Helmet>
        <title>Alpha Targeting || PerformanceReport</title>
      </Helmet>
      <Paper elevation={3}>
        <Container maxWidth="xl">
          <Stack spacing={4}>
            <Box>
              <Stack
                direction={"row"}
                gap={2}
                sx={{
                  mt: 2,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  onClick={() => setToggleCalender(!toggleCalender)}
                  startIcon={<CalendarMonth sx={{ color: "#6b7280" }} />}
                  variant="outlined"
                  sx={{
                    fontWeight: 600,
                    fontSize: "13px",
                    color: "#374151",
                    borderColor: "#e0e0e0",
                    bgcolor: "#fff",
                    textTransform: "none",
                    height: "40px",
                    borderRadius: "8px",
                    px: 2,
                    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                    "&:hover": {
                      borderColor: "#d1d5db",
                      bgcolor: "#f9fafb",
                    },
                  }}
                >
                  {calanderDateConverter(
                    dateRanges[0].startDate,
                    dateRanges[0].endDate,
                  )}
                </Button>

                <FormControl size="small" sx={{ width: 200 }}>
                  <InputLabel
                    id="campaign"
                    sx={{ fontSize: "13px", color: "#6b7280" }}
                  >
                    Select Campaign
                  </InputLabel>
                  <Select
                    labelId="campaign"
                    id="campaign"
                    value={campaign}
                    label="Select Campaign"
                    onChange={(e) => setCampaign(e.target.value)}
                    sx={{
                      height: "40px",
                      borderRadius: "8px",
                      bgcolor: "#fff",
                      fontSize: "13px",
                      boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#e0e0e0",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#d1d5db",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#9ca3af",
                        borderWidth: "1px",
                      },
                    }}
                  >
                    <MenuItem value={""} sx={{ fontSize: "13px" }}>
                      None
                    </MenuItem>
                    {campFilterData &&
                      campFilterData.map((item, index) => (
                        <MenuItem
                          key={item.campaign}
                          value={`${item.campaign}`}
                          sx={{ fontSize: "13px" }}
                        >
                          {item.campaign}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>

                <FormControl size="small" sx={{ width: 200 }}>
                  <InputLabel
                    id="network"
                    sx={{ fontSize: "13px", color: "#6b7280" }}
                  >
                    Select Network
                  </InputLabel>
                  <Select
                    labelId="network"
                    id="network"
                    value={partner}
                    label="Select Network"
                    onChange={(e) => setPartner(e.target.value)}
                    sx={{
                      height: "40px",
                      borderRadius: "8px",
                      bgcolor: "#fff",
                      fontSize: "13px",
                      boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#e0e0e0",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#d1d5db",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#9ca3af",
                        borderWidth: "1px",
                      },
                    }}
                  >
                    <MenuItem value={""} sx={{ fontSize: "13px" }}>
                      None
                    </MenuItem>
                    {networkFilterData &&
                      networkFilterData.map((item, index) => (
                        <MenuItem
                          key={item.network}
                          value={`${item.network}`}
                          sx={{ fontSize: "13px" }}
                        >
                          {item.network}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>

                <FormControl size="small" sx={{ width: 200 }}>
                  <InputLabel
                    id="login_id"
                    sx={{ fontSize: "13px", color: "#6b7280" }}
                  >
                    Select LoginId
                  </InputLabel>
                  <Select
                    labelId="login_id"
                    id="login_id"
                    value={login_id}
                    label="Select LoginId"
                    onChange={(e) => setLogin_id(e.target.value)}
                    sx={{
                      height: "40px",
                      borderRadius: "8px",
                      bgcolor: "#fff",
                      fontSize: "13px",
                      boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#e0e0e0",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#d1d5db",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#9ca3af",
                        borderWidth: "1px",
                      },
                    }}
                  >
                    <MenuItem value={""} sx={{ fontSize: "13px" }}>
                      None
                    </MenuItem>
                    {loginIdFilterData &&
                      loginIdFilterData.map((item, index) => (
                        <MenuItem
                          key={item.login_id}
                          value={`${item.login_id}`}
                          sx={{ fontSize: "13px" }}
                        >
                          {item.login_id}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Stack>
              {/* hidden date  */}
              <Box sx={{ position: "relative" }}>
                {toggleCalender && (
                  <Box
                    sx={{
                      position: "absolute",
                      backgroundColor: "white",
                      zIndex: 100,
                      boxShadow:
                        " 0px 3.7px 4.4px rgba(0, 0, 0, 0.056), 0px 10.1px 12.3px rgba(0, 0, 0, 0.08),0px 24.4px 29.5px rgba(0, 0, 0, 0.104), 0px 81px 98px rgba(0, 0, 0, 0.16)",
                      left: "50%",
                      transform: "TranslateX(-50%)",
                    }}
                  >
                    <DateRangePicker
                      ranges={dateRanges}
                      onChange={(item) => {
                        // console.log(item, "select item");
                        handleDateChange(item);
                      }}
                      showSelectionPreview={true}
                      moveRangeOnFirstSelection={false}
                      months={2}
                      // shouldCloseOnSelect={false}
                      direction="horizontal"
                      staticRanges={customStaticRanges} // Add custom preset options
                    />
                  </Box>
                )}
              </Box>

              {/* stateCard */}
              <Box mt={4} width={"100%"}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4}>
                    <Paper
                      elevation={0}
                      sx={{
                        p: 2.5,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        borderRadius: 3,
                        height: "100%",
                        bgcolor: "#fff",
                        border: "1px solid #e5e7eb",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                      }}
                    >
                      <Box
                        sx={{
                          fontSize: "0.9rem",
                          fontWeight: 600,
                          color: "#374151",
                          mb: 2,
                          pb: 1.5,
                          position: "relative",
                          "&::after": {
                            content: '""',
                            position: "absolute",
                            bottom: 0,
                            left: 0,
                            right: 0,
                            height: "2px",
                            background:
                              "linear-gradient(90deg, rgba(17, 24, 39, 0.4), rgba(17, 24, 39, 0.4), transparent)",
                          },
                          textTransform: "capitalize",
                        }}
                      >
                        Total Clicks
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "baseline",
                        }}
                      >
                        <Box
                          sx={{
                            fontSize: "0.8rem",
                            color: "#6b7280",
                            fontWeight: 500,
                          }}
                        >
                          Clicks
                        </Box>
                        <Box
                          sx={{
                            fontSize: "1.25rem",
                            fontWeight: 700,
                            color: "#111827",
                          }}
                        >
                          {indianNumberFormatter(
                            campGraphResult?.total_state?.sum_clicks,
                          )}
                        </Box>
                      </Box>
                    </Paper>
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <Paper
                      elevation={0}
                      sx={{
                        p: 2.5,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        borderRadius: 3,
                        height: "100%",
                        bgcolor: "#fff",
                        border: "1px solid #e5e7eb",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                      }}
                    >
                      <Box
                        sx={{
                          fontSize: "0.9rem",
                          fontWeight: 600,
                          color: "#374151",
                          mb: 2,
                          pb: 1.5,
                          position: "relative",
                          "&::after": {
                            content: '""',
                            position: "absolute",
                            bottom: 0,
                            left: 0,
                            right: 0,
                            height: "2px",
                            background:
                              "linear-gradient(90deg, rgba(17, 24, 39, 0.4), rgba(17, 24, 39, 0.4), transparent)",
                          },
                          textTransform: "capitalize",
                        }}
                      >
                        Revenue
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Box sx={{ display: "flex", flexDirection: "column" }}>
                          <Box
                            sx={{
                              fontSize: "0.8rem",
                              color: "#6b7280",
                              fontWeight: 500,
                              mb: 0.5,
                            }}
                          >
                            Approved
                          </Box>
                          <Box
                            sx={{
                              fontSize: "1.1rem",
                              fontWeight: 700,
                              color: "#111827",
                            }}
                          >
                            {indianNumberFormatter(
                              campGraphResult?.total_state?.sum_approved,
                            )}
                          </Box>
                        </Box>
                        <Box sx={{ display: "flex", flexDirection: "column" }}>
                          <Box
                            sx={{
                              fontSize: "0.8rem",
                              color: "#6b7280",
                              fontWeight: 500,
                              mb: 0.5,
                            }}
                          >
                            Pending
                          </Box>
                          <Box
                            sx={{
                              fontSize: "1.1rem",
                              fontWeight: 700,
                              color: "#111827",
                            }}
                          >
                            {indianNumberFormatter(
                              campGraphResult?.total_state?.sum_pending,
                            )}
                          </Box>
                        </Box>
                        <Box sx={{ display: "flex", flexDirection: "column" }}>
                          <Box
                            sx={{
                              fontSize: "0.8rem",
                              color: "#6b7280",
                              fontWeight: 500,
                              mb: 0.5,
                            }}
                          >
                            Cancelled
                          </Box>
                          <Box
                            sx={{
                              fontSize: "1.1rem",
                              fontWeight: 700,
                              color: "#111827",
                            }}
                          >
                            {indianNumberFormatter(
                              campGraphResult?.total_state?.sum_cancelled,
                            )}
                          </Box>
                        </Box>
                      </Box>
                    </Paper>
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <Paper
                      elevation={0}
                      sx={{
                        p: 2.5,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        borderRadius: 3,
                        height: "100%",
                        bgcolor: "#fff",
                        border: "1px solid #e5e7eb",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                      }}
                    >
                      <Box
                        sx={{
                          fontSize: "0.9rem",
                          fontWeight: 600,
                          color: "#374151",
                          mb: 2,
                          pb: 1.5,
                          position: "relative",
                          "&::after": {
                            content: '""',
                            position: "absolute",
                            bottom: 0,
                            left: 0,
                            right: 0,
                            height: "2px",
                            background:
                              "linear-gradient(90deg, rgba(17, 24, 39, 0.4), rgba(17, 24, 39, 0.4), transparent)",
                          },
                          textTransform: "capitalize",
                        }}
                      >
                        Conversions
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Box sx={{ display: "flex", flexDirection: "column" }}>
                          <Box
                            sx={{
                              fontSize: "0.8rem",
                              color: "#6b7280",
                              fontWeight: 500,
                              mb: 0.5,
                            }}
                          >
                            Conversion
                          </Box>
                          <Box
                            sx={{
                              fontSize: "1.1rem",
                              fontWeight: 700,
                              color: "#111827",
                            }}
                          >
                            {indianNumberFormatter(
                              campGraphResult?.total_state?.sum_conversions,
                            )}
                          </Box>
                        </Box>
                        <Box sx={{ display: "flex", flexDirection: "column" }}>
                          <Box
                            sx={{
                              fontSize: "0.8rem",
                              color: "#6b7280",
                              fontWeight: 500,
                              mb: 0.5,
                            }}
                          >
                            Approved
                          </Box>
                          <Box
                            sx={{
                              fontSize: "1.1rem",
                              fontWeight: 700,
                              color: "#111827",
                            }}
                          >
                            {indianNumberFormatter(
                              campGraphResult?.total_state
                                ?.sum_approved_conversion,
                            )}
                          </Box>
                        </Box>
                        <Box sx={{ display: "flex", flexDirection: "column" }}>
                          <Box
                            sx={{
                              fontSize: "0.8rem",
                              color: "#6b7280",
                              fontWeight: 500,
                              mb: 0.5,
                            }}
                          >
                            Cancelled
                          </Box>
                          <Box
                            sx={{
                              fontSize: "1.1rem",
                              fontWeight: 700,
                              color: "#111827",
                            }}
                          >
                            {indianNumberFormatter(
                              campGraphResult?.total_state
                                ?.sum_cancelled_conversion,
                            )}
                          </Box>
                        </Box>
                      </Box>
                    </Paper>
                  </Grid>
                </Grid>
              </Box>

              {/* graph */}
              <Box mt={2}>
                <RechartsLineChart data={chartData} {...chartProps} />
              </Box>
            </Box>
            <Datatable
              rows={campTableDataFilteredRows}
              columns={columns}
              getRowId={(row, index) => `${row.campaign}-${index}`}
              table_name={"Campaign Table"}
              // paginationModel={paginationModel}
              // onPaginationModelChange={handleCampaignPagination}
              // rowCount={total_camp_count}
              search={true}
              onSearchTermChange={setCampainSearchTerm}
            />

            <Datatable
              rows={networkTableDataFilteredRows}
              columns={networkColumns}
              getRowId={(row, index) => `${row.network}-${index}`}
              table_name={"Network Table"}
              // paginationModel={paginationModelNetwork}
              // onPaginationModelChange={handleNetworkPagination}
              // rowCount={total_network_count}
              search={true}
              onSearchTermChange={setNetworkSearchTerm}
            />
          </Stack>
        </Container>
      </Paper>
    </>
  );
}

export default FIlterChart;
